import { render, staticRenderFns } from "./LoadingZone.vue?vue&type=template&id=b8717834&scoped=true&"
import script from "./LoadingZone.vue?vue&type=script&lang=ts&"
export * from "./LoadingZone.vue?vue&type=script&lang=ts&"
import style0 from "./LoadingZone.vue?vue&type=style&index=0&id=b8717834&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8717834",
  null
  
)

export default component.exports